import React from 'react';
import { useQuery } from 'react-apollo';
import styled from '@emotion/styled';
import { Switch } from '@material-ui/core';
import { FIND_WHITE_LABEL } from '../../../../../graphql/queryes';
import { TextField } from '../../../../../components/TextField';

export const DadosForm = ({ handleDadosCadastrais, dadosCadastrais }) => {
  const { data: whitelabelData } = useQuery(FIND_WHITE_LABEL);
  const whitelabel = whitelabelData?.findEntidadeLogada?.whitelabel?.nome;
  const isTaip = whitelabel === 'TAIP_SAUDE';

  const campos = [
    {
      label: 'Nome',
      placeholder: 'Digite o seu nome completo',
      key: 'nome',
    },
    {
      label: 'CPF',
      placeholder: 'Digite o cpf',
      key: 'cpf',
      mask: 'cpf',
    },
    {
      label: 'Telefone',
      placeholder: 'Digite o telefone',
      key: 'telefone',
      mask: 'phone',
    },
    {
      label: 'Email',
      placeholder: 'Digite o email',
      key: 'email',
    },
  ];
  return (
    <>
      {<Subtitle>Informe os dados pessoais:</Subtitle>}
      {campos.map((campo) => (
        <Row key={campo.key}>
          <TextField
            label={campo.label}
            placeholder={campo.placeholder}
            value={dadosCadastrais?.[campo.key]}
            mask={campo.mask}
            onChange={(e) => handleDadosCadastrais(e.target.value, campo.key)}
          />
        </Row>
      ))}
      {isTaip && (
        <Row style={{ alignItems: 'center' }}>
          <AtivoLabel>Ativo</AtivoLabel>
          <Switch
            checked={dadosCadastrais.ativo}
            color="primary"
            onChange={(e) => handleDadosCadastrais(e.target.checked, 'ativo')}
          >
            {' '}
          </Switch>
        </Row>
      )}
    </>
  );
};

const Row = styled.div`
  display: flex;
  gap: 5px;
`;
const AtivoLabel = styled.span`
  color: rgba(0, 0, 0, 0.54);
`;
const Subtitle = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;
